module.exports = __webpack_public_path__ + "static/img/logo_jidian.cc75e873.png";